import * as React from 'react';

import { $catalyticItems } from '@rematter/modules/trade/_state/loadForm.state';
import { useCatalyticSizeOptions } from '@rematter/modules/trade/hooks/useCatalyticSizeOptions';
import { CatalyticConverterSize } from '@rematter/modules/trade/types/load';
import { TouchSelect } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { ItemFieldProps } from '../_types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

//
// ⚛️ ⚛️ ⚛️ CATALYTIC SIZE FIELD ⚛️ ⚛️ ⚛️
//
export const CatalyticSizeField: React.FC<ItemFieldProps> = ({
  lineItem,
  disabled,
  onUpdateItem,
}) => {
  // Translation
  const t = useTranslations();

  // Atoms
  const catalyticItems = useAtomValue($catalyticItems);

  // Other data
  const currentItem = React.useMemo(
    () => catalyticItems.find((item) => item.id === lineItem.itemId),
    [catalyticItems, lineItem.itemId],
  );

  // Other Hooks
  const { currentSize, availableSizeOptions, findItemIdForSize } =
    useCatalyticSizeOptions(currentItem);

  // Callbacks
  const handleChangeOption = React.useCallback(
    (selectedSize?: string) => {
      if (!selectedSize) return;

      const matchingItemId = findItemIdForSize(
        selectedSize as CatalyticConverterSize,
      );

      if (matchingItemId) {
        onUpdateItem(lineItem.id, { itemId: matchingItemId });
      }
    },
    [findItemIdForSize, lineItem.id, onUpdateItem],
  );

  return (
    <TouchSelect
      value={currentSize}
      onChange={handleChangeOption}
      isDisabled={disabled || !availableSizeOptions.length}
      options={availableSizeOptions}
      aria-label={t.scaleTicketPro.itemsInterface.catalyticConverterSize}
      className="@CatalyticSizeField"
    />
  );
};
